import { info, warning, error } from './lib/ServerLog';

export const ServerLog = { info, warning, error };
